import { createContext, ReactNode, useContext } from "react";
import { ConfigurationGetResponse, CountryOption, SessionGetResponse } from "ClientApi/ClientApi";
import { Dictionary } from "aphrodite.react/Helpers";

interface AppContextState {
    resourceNode: (key: string | null, variables?: Dictionary<string | number | ReactNode>) => string | ReactNode;
    resource: (key: string | null, variables?: Dictionary<string | number>) => string;
    session: SessionGetResponse | null;
    refreshSession: () => Promise<void>;
    countries: CountryOption[] | null;
    configuration: ConfigurationGetResponse | null;
    inApp: boolean;
    noBackNav: boolean;
}

export const AppContext = createContext<AppContextState>({
    resourceNode: () => {
        return "No resource finder has been implemented";
    },
    resource: () => {
        return "No resource finder has been implemented";
    },
    session: null,
    refreshSession: () => Promise.reject(),
    countries: null,
    configuration: null,
    inApp: false,
    noBackNav: false
});

export function useApp() {
    return useContext(AppContext);
};
